import React from 'react'

export default function Footer() {
    return (
        <div className="footer">
            &copy; all right reserved | design by yousef ayman
        </div>
    )
}
